import { ComponentType, lazy, LazyExoticComponent } from "react";

// When a lazily-imported chunk 404s after a deploy (new hashes, old index.html),
// Vercel's catch-all rewrite serves index.html instead — triggering a MIME error.
// This wrapper detects that, reloads once to get the fresh index.html, then gives up
// (loop guard: only one reload per 10-second window to avoid infinite reload loops).
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- mirrors React.lazy's signature
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(() =>
    factory().catch((error: unknown) => {
      const key = "chunkLoadLastReload";
      const lastReload = Number(sessionStorage.getItem(key) ?? 0);
      if (Date.now() - lastReload > 10_000) {
        sessionStorage.setItem(key, String(Date.now()));
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }),
  );
}
